import {Button, Flex} from 'antd';
import React from 'react';

import getLogo from '../../utils/getLogo';
import errorText from '../../assets/images/error_boundary_bg_text.png';
import leftIce from '../../assets/images/error_boundary_left_ice_bg.png';
import rightIce from '../../assets/images/error_boundary_right_ice_bg.png';

import 'antd/dist/reset.css';
import './ErrorBoundaryFallback.scss';

const logo = getLogo();

export default function ErrorBoundaryFallback() {
  return (
    <div className="error-boundary-fallback">
      <Flex justify="center">
        <div className="logo-container">
          <img src={logo} alt="logo" />
        </div>
      </Flex>
      <Flex justify="center" style={{flexGrow: 1}}>
        <div className="error-container">
          <div className="woops">
            <img src={errorText} alt="woops" />
          </div>
          <div className="leftIce">
            <img src={leftIce} alt="left_ice" />
          </div>
          <div className="rightIce">
            <img src={rightIce} alt="right_ice" />
          </div>
          <div className="message-container">
            <div className="header_wrapper">
              <h1>There is a problem on our end</h1>
              <span>Please, try to refresh the page</span>
            </div>
            <div className="buttons-wrapper">
              <Button type="primary" onClick={() => window.location.reload()}>Refresh Page</Button>
              <Button type="text" onClick={() => window.location.replace('/')}>Go Back</Button>
            </div>
          </div>
        </div>
      </Flex>
    </div>
  );
}
